import { Identifiable } from './identifiable';
import { BaseEntity } from './base-entity';

export class AssessmentDistributionRequest {
  dueDate: Date;
  targetEntity: BaseEntity; // includes name and type
  formula: Identifiable;
  threats: Array<Identifiable> = [];
  users: Array<Identifiable> = [];
  name: string;
}
